import { Box, BoxProps, Image } from '@jfs/ui-new'
import { FC } from 'react'
import { useIsMobile } from '../../util/useFontSize'
const ImageDotted = require('../../assets/images/dotted-background.png')
const ImageLight = require('../../assets/images/dotted-white.png')

export enum dottedImageTypes {
  top = 'Top',
  bottom = 'Bottom',
  topLeft = 'TopLeft',
  topRight = 'Topright',
  bottomLeft = 'Bottomleft',
  bottomRight = 'BottomRight',
  bottomRightZero = 'BottomRightZero',
  default = 'Default',
}
interface ImageDottedProps {
  position: dottedImageTypes
  opacity?: number
  isDark?: boolean
  size?: number
}
const DottedImage: FC<ImageDottedProps> = ({
  position = 'Default',
  isDark = true,
  size,
  opacity,
}: ImageDottedProps) => {
  const imageStyle = styles[position]
  const isMobile = useIsMobile()
  return (
    <Box {...imageStyle} opacity={opacity ?? 1}>
      <Image
        resizeMode="contain"
        source={isDark ? ImageDotted : ImageLight}
        {...styles.imageDottedSize(isMobile, size)}
      />
    </Box>
  )
}

export const styles = {
  Top: {
    position: 'absolute',
    left: -13,
    zIndex: -2,
  } as BoxProps,
  Bottom: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: -1,
  } as BoxProps,
  Topright: {
    position: 'absolute',
    right: 13,
    zIndex: -1,
  } as BoxProps,
  TopLeft: {
    position: 'absolute',
    left: 13,
    top: -10,
    zIndex: -1,
  } as BoxProps,
  Bottomleft: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    zIndex: -1,
  } as BoxProps,
  BottomRightZero: {
    position: 'absolute',
    bottom: -10,
    right: 13,
    zIndex: -1,
  } as BoxProps,
  BottomRight: {
    position: 'absolute',
    bottom: -40,
    right: '-10%',
    zIndex: -1,
  } as BoxProps,
  Default: {
    position: 'absolute',
    zIndex: -2,
  } as BoxProps,
  imageDottedSize: (isMobile: boolean, size: number | undefined) => {
    return {
      width: size ? size : isMobile ? 150 : 260,
      height: size ? size : isMobile ? 150 : 260,
    }
  },
}

export default DottedImage
